import React from "react"
import { useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { MdClose } from "react-icons/md"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { haveAuth } from "utils"
import { Navbar, } from "components"
import { useClickOutside } from "hooks"
import OrdersTabBadge from "./OrdersTabBadge"
import classes from "./OrdersSidebar.module.scss"

const OrdersSidebar = props => {
  const {
    setFilters,
    setOrderCode,
    currentTab,
    setCurrentTab,
    openOrderSidebar,
    setOpenOrderSidebar
  } = props

  const [t, i18n] = useTranslation()

  const history = useHistory()

  const notViewedOrders =
    useSelector(state => state.notViewedOrders.notViewedOrders)

  const notViewedOfflineOrders =
    useSelector(state =>
      state.offlineOrders.filter(o => !o.isViewed).length
    )

  useClickOutside(() => {
    setOpenOrderSidebar(false)
  }, ["order-sidebar", "order-hamburger-button"])

  const handlePress = (name) => {
    if (currentTab === name) return

    setCurrentTab(name)

    setOrderCode("")

    setFilters(prev => ({
      ...prev,
      statusMultiple: [name]
    }))

    openOrderSidebar &&
      setOpenOrderSidebar(false)
  }

  const showOrderNotesTab =
    haveAuth(["viewUnconfirmedOrders"])

  const showOrdersTab =
    haveAuth(["viewLatestOrders"])

  const showPaymentProblematicOrdersTab =
    haveAuth(["checkout"])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div
      id="order-sidebar"
      className={clsx(
        classes["container"],
        isLtr && classes["container-ltr"],
        openOrderSidebar && classes["show"],
        openOrderSidebar && isLtr && classes["show-ltr"],
      )}
    >
      <Navbar
        variant="compact"
        title={t("سفارشات")}
        hideLeftIconInMobileView
        onLeftIconPress={() => history.push("/foods")}
        rightSideComponent={() =>
          <button
            className={classes["close"]}
            onClick={() => setOpenOrderSidebar(false)}
          >
            <MdClose
              color="white"
              size={25}
            />
          </button>
        }
      />
      {
        showOrdersTab &&
        <div
          onClick={() => handlePress("pending")}
          className={clsx(
            classes["tab"],
            currentTab === "pending" && classes["active"]
          )}
        >
          <span>{t("سفارشات_پرداخت_نشده")}</span>
          <OrdersTabBadge
            number={notViewedOrders.pending}
          />
        </div>
      }

      {
        showOrdersTab &&
        <div
          onClick={() => handlePress("paid")}
          className={clsx(
            classes["tab"],
            currentTab === "paid" && classes["active"]
          )}
        >
          <span>{t("سفارشات_پرداخت_شده")}</span>
          <OrdersTabBadge
            number={notViewedOrders.paid}
          />
        </div>
      }

      {
        haveAuth(["viewOrderHistory"]) &&
        <div
          onClick={() => handlePress("delivered")}
          className={clsx(
            classes["tab"],
            currentTab === "delivered" && classes["active"]
          )}
        >
          {t("سفارشات_تکمیل_شده")}
        </div>
      }

      {
        showPaymentProblematicOrdersTab &&
        <div
          onClick={() => handlePress("paymentProblematic")}
          className={clsx(
            classes["tab"],
            currentTab === "paymentProblematic" && classes["active"]
          )}
        >
          <span>{t("سفارشات_تایید_نشده")}</span>
        </div>
      }

      {
        showOrdersTab &&
        <div
          onClick={() => handlePress("canceled")}
          className={clsx(
            classes["tab"],
            currentTab === "canceled" && classes["active"]
          )}
        >
          <span>{t("سفارشات_لغو_شده")}</span>
          <OrdersTabBadge
            number={notViewedOrders.canceled}
          />
        </div>
      }

      {
        showOrderNotesTab &&
        <div
          onClick={() => handlePress("temp")}
          className={clsx(
            classes["tab"],
            currentTab === "temp" && classes["active"]
          )}
        >
          <span>{t("سفارشات_در_انتظار_تایید")}</span>
          <OrdersTabBadge
            number={notViewedOrders.notConfirmed}
          />
        </div>
      }
      {
        showOrdersTab &&
        <div
          onClick={() => handlePress("offline")}
          className={clsx(
            classes["tab"],
            currentTab === "offline" && classes["active"]
          )}
        >
          <span>{t("سفارشات_آفلاین")}</span>
          <OrdersTabBadge
            number={notViewedOfflineOrders}
          />
        </div>
      }
      {
        showOrdersTab &&
        <div
          onClick={() => handlePress("late")}
          className={clsx(
            classes["tab"],
            currentTab === "late" && classes["active"]
          )}
        >
          <span>{t("سفارشات_تاخیر_خورده")}</span>
        </div>
      }
      {
        showOrdersTab &&
        <div
          onClick={() => handlePress("ready")}
          className={clsx(
            classes["tab"],
            currentTab === "ready" && classes["active"]
          )}
        >
          <span>{t("سفارشات_آماده_تحویل")}</span>
        </div>
      }
    </div>
  )
}

export default OrdersSidebar